import { useTrackMutation } from '@mote/api'
import { Downloader } from '@mote/helpers'
import { TRACK_EVENT_NAMES } from '@mote/helpers/constants'

export function useMoteDownload(moteId: string, url: string) {
  const trackMutation = useTrackMutation()
  async function handleOnDownload() {
    const filename = `mote-${moteId}`
    if (url.startsWith('blob:')) {
      Downloader.getFromBlobUrl(url, filename)
    } else {
      await Downloader.getFromFetch(url, filename)
    }

    //@ts-expect-error
    trackMutation.mutate({
      variables: {
        event: TRACK_EVENT_NAMES.mote.action.download
      }
    })
  }

  return handleOnDownload
}
